import { useApi, useToaster, type CustomerStoryIndustry } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { watch } from "vue";

export function useCustomerStoryIndustries() {
    const api = useApi();
    const toaster = useToaster();

    const query = useQuery<CustomerStoryIndustry[]>({
        queryKey: ["expert", "customer-stories", "industries"],
        queryFn: () => api.expert.getCustomerStoryIndustries(),
        staleTime: 30 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    watch(() => query.error.value, (error) => {
        if (!error) return;
        toaster.create({ title: "Failed to load industries", type: "error" });
    });

    return query;
}

export default useCustomerStoryIndustries;
